import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  
  connect() {
    // Encode the URL properly
    const encodedUrl = encodeURIComponent(window.location.pathname)
    
    fetch(`/pins/check_pinned?url=${encodedUrl}`, {
      headers: {
        "Accept": "application/json"
      },
      credentials: 'same-origin'
    })
    .then(response => {
      if (response.status === 401 || response.status === 403) {
        return { pinned: false }
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      this.updateButtonState(data.pinned)
    })
    .catch(() => {
      this.updateButtonState(false)
    })
  }
  
  toggle() {
    const url = this.element.dataset.pinUrl
    const pinData = {
      title: this.element.dataset.pinTitle || document.title,
      url: window.location.pathname,
      icon: this.element.dataset.pinIcon,
      pinnable_type: this.element.dataset.pinPinnableType,
      pinnable_id: this.element.dataset.pinPinnableId
    }
    
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      credentials: 'same-origin',
      body: JSON.stringify(pinData)
    })
    .then(response => {
      if (response.status === 401 || response.status === 403) {
        throw new Error('Not authenticated')
      }
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(data => {
      this.updateButtonState(data.pinned)
      this.refreshPinsList()
    })
    .catch(() => {
      // Silently fail
    })
  }
  
  removePin(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const toggleUrl = this.element.dataset.pinUrl
    const pinData = {
      title: this.element.dataset.pinTitle,
      url: this.element.dataset.pinTargetUrl,
      icon: this.element.dataset.pinIcon,
      pinnable_type: this.element.dataset.pinPinnableType,
      pinnable_id: this.element.dataset.pinPinnableId
    }
    
    fetch(toggleUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      },
      credentials: 'same-origin',
      body: JSON.stringify(pinData)
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
    .then(() => {
      this.refreshPinsList()
    })
    .catch(() => {
      // Silently fail
    })
  }
  
    updateButtonState(isPinned) {
    // Only update the icon if this is the main pin button, not a remove button
    if (this.element.dataset.action && this.element.dataset.action.includes('removePin')) {
      return; // Don't change the icon for remove buttons
    }
    
    const icon = this.element.querySelector("iconify-icon")
    if (icon) {
      icon.setAttribute("icon", isPinned ? "ph:push-pin-simple" : "ph:push-pin-light")
      this.element.classList.toggle("btn-primary", isPinned)
    }
  }
  
  refreshPinsList() {
    const frame = document.querySelector("#pins-list")
    if (frame) {
      frame.src = "/pins/list"
      frame.reload()
    }
  }
} 